(function ($) {
  window.matchCommentsToggleStates = window.matchCommentsToggleStates || {};

  function setupToggle() {
    $('.match-comments__toggle').each(function () {
      const $toggle = $(this);
      const $body = $toggle.next('.match-comments__body');
      const toggleKey = $toggle.data('toggle-key');

      if (!$body.length) return;

      const wasOpen = window.matchCommentsToggleStates[toggleKey];
      if (wasOpen) {
        $body.addClass('is-open');
        $toggle.addClass('is-open');
        $body.css('height', 'auto');
      } else {
        $body.css('height', '0px');
        $body.removeClass('is-open');
        $toggle.removeClass('is-open');
      }
    });
  }

  $(document).on('click', '.match-comments__toggle', function (e) {
    e.preventDefault();

    const $toggle = $(this);
    const $body = $toggle.next('.match-comments__body');
    const toggleKey = $toggle.data('toggle-key');

    if (!$body.length) return;

    const isOpen = $toggle.hasClass('is-open');

    if (isOpen) {
      $body.css('height', $body[0].scrollHeight + 'px');
      $body[0].offsetHeight;

      $body.css('height', '0px').removeClass('is-open');

      $toggle.removeClass('is-open');

      window.matchCommentsToggleStates[toggleKey] = false;
    } else {
      $body.addClass('is-open');
      $toggle.addClass('is-open');

      const height = $body[0].scrollHeight;
      $body.css('height', height + 'px');

      $body.one('transitionend', function (e) {
        if (e.originalEvent.propertyName === 'height' && $body.hasClass('is-open')) {
          $body.css('height', 'auto');
        }
      });

      window.matchCommentsToggleStates[toggleKey] = true;
    }
  });

  $(document).ready(setupToggle);
  $(document).on('live-game-refreshed', setupToggle);
})(jQuery);
